/**
 * [TD-101 fix - Feb 2026] Auction round-rollover math, extracted as a
 * standalone pure function (zero framework/axios deps) so it is
 * unit-testable under Jest without pulling in DraftContext.js's import
 * chain (axios / AuthContext / react-router-dom), which is unresolvable
 * under the current CRA jest config per TD-76.
 *
 * Auction has no server-side "round" concept - a round is one full pass
 * through `nomination_order`. Adam's "Round N begins" announcement
 * (DraftContext.js NOMINATION_READY handler) must feed this from the
 * UNTRIMMED total-sales count (`totalSalesCountRef`, bootstrapped from
 * `GET /full-history` + WS dedup) - never `completed_sales.length`,
 * which the backend caps to the last 20 entries in `DraftEngine.to_dict()`.
 */
export function computeAuctionRoundRollover(totalSales, orderLen) {
  const isRoundRollover =
    orderLen > 0 && totalSales > 0 && totalSales % orderLen === 0;
  const nextRound = orderLen > 0 ? Math.floor(totalSales / orderLen) + 1 : 0;
  return { isRoundRollover, nextRound };
}
